import React, { useState, useEffect } from "react";
import { User } from "../../../../api";
import { Loader, Dropdown } from "semantic-ui-react";
import { map, size, filter } from "lodash";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../../../hooks";
import { UserItem } from "../UserItem/UserItem";

const usercontroller = new User();

export function ListUsers(props) {
  const { userActive, reload, onReload } = props;
  // Dos namespaces: el propio y el comun, del que sale "Institución".
  const { t } = useTranslation(["misc", "common"]);
  const [users, setUsers] = useState(null);
  const [selectedRole, setSelectedRole] = useState("admin");
  const { accessToken } = useAuth();

  // La lista baja dentro del componente porque su texto depende del idioma
  // activo: si se queda en el modulo se congela con el idioma del arranque.
  // El `value` es la clave que viaja al filtro y NO se traduce nunca.
  const roleOptions = [
    { key: "all", value: "all", text: t("users.list.allRoles") },
    { key: "admin", value: "admin", text: t("users.roles.admin") },
    { key: "user", value: "user", text: t("users.roles.user") },
    { key: "client", value: "client", text: t("users.roles.client") },
    { key: "partner", value: "partner", text: t("users.roles.partner") },
    { key: "teacher", value: "teacher", text: t("users.roles.teacher") },
    { key: "student", value: "student", text: t("users.roles.student") },
    {
      key: "institution",
      value: "institution",
      text: t("common:roles.institution"),
    },
  ];

  useEffect(() => {
    (async () => {
      try {
        setUsers(null);
        const response = await usercontroller.getUsers(accessToken, userActive);
        if (response.users && response.users.length > 0) {
          setUsers(response.users);
        } else {
          setUsers([]);
        }
      } catch (error) {
        console.error(error);
      }
    })();
  }, [userActive, reload, accessToken]);

  const handleRoleChange = (_, { value }) => {
    setSelectedRole(value);
  };

  const filteredUsers =
    selectedRole === "all"
      ? users
      : filter(users, (user) => user.role === selectedRole);

  if (!users) {
    return <Loader active inline="centered" />;
  }

  return (
    <>
      {/* Dropdown para seleccionar el rol */}
      <Dropdown
        placeholder={t("users.rolePlaceholder")}
        fluid
        selection
        options={roleOptions}
        onChange={handleRoleChange}
        value={selectedRole}
        style={{ marginBottom: "1em" }}
      />

      {/* Mostrar mensaje si no hay usuarios para el rol seleccionado */}
      {size(filteredUsers) === 0 ? (
        <p>{t("users.list.emptyForRole")}</p>
      ) : (
        map(filteredUsers, (user) => (
          <UserItem key={user._id} user={user} onReload={onReload} />
        ))
      )}
    </>
  );
}
